// @flow
const RESULTS_VIEW_TYPES = {
  AUTO: "auto",
  LIST: "list",
  AGGREGATE: "aggregate",
}

export default RESULTS_VIEW_TYPES
